module.exports = __webpack_public_path__ + "static/media/play-boss-pass.f2390177.png";